import{useSelector}from'react-redux';const useNavigation=()=>{return useSelector(state=>state.navigation);};export default useNavigation;